$(document).ready(function() {
  $(document).on('change', '#product_set_document', function() {
    $(this).closest('.fields').find('a.button.delete').removeClass('hide');
    filename = $(this).closest('.file-input-btn').find('.filename');
    filename.removeClass('hide');
  });

  $(document).on('click', "form.edit_product_set .upload-section .fields a.button.delete", function() {
    filename = $(this).closest('.file-input-btn').find('.filename');
    filename.html('');
    filename.addClass('hide');
    $('#product_set_document').val('');
    return $(this).addClass('hide');
  });

  if($('#product_set_developer_id').length > 0){
    selectizer = $('#product_set_developer_id').selectize({
      valueField: 'id',
      labelField: 'text',
      searchField: 'text',
      onInitialize: function(){
        $("<div id='developer-selectize-error'>").appendTo(this.$wrapper);
        this.$control_input.attr("data-parsley-errors-container", "#developer-selectize-error");
      },
      options: [],
      maxItems: 1,
      highlight: false,
      render: {
          option: function(item, escape) {
              return `<div class="with-avatar">
              <div class="avatar avatar-s">
                <img src="${item.image}" />
              </div>
              <span>${item.text}</span>
            </div>`;
          }
      },
      preload: true,
      load: function(query, callback){
        $.ajax('/companies/auto_complete_search?state=approved', {
          type: 'get',
          data: {
            q: query
          },
          success: function(res) {
            callback(res);
          }
        })
      }
    })[0].selectize;
  }

  if($('#product_set_currency').length > 0){
    $('#product_set_currency').selectize({})
  }

  var selectize_product_fields = () => $('select[id*=company_product_id]').selectize({
    sortField: 'text',
    onInitialize: function(){
      var errorContainerId = this.$control_input.attr('id')+'-selectize-error';

      $("<div id="+errorContainerId+">").appendTo(this.$wrapper);
      this.$control_input.attr("data-parsley-errors-container", "#"+errorContainerId)
    },
    render: {
      option: function(item, escape){
        return `<div><div class='product-thumb'><img src=${item.image}></img></div><div class=name-address-container><div class='product-name'>${item.text}</div></div></div>`
      }
    }
  })

  var selectize_unit_fields = () => $('select[id*=unit]').selectize({create: true, sortField: 'text'})

  $(document).on('click', '#add-new-specification-btn', () => setTimeout((function() {
    selectize_product_fields();
    selectize_unit_fields();
  }), 100));

  setTimeout((function() {
      selectize_unit_fields();
      selectize_product_fields();
  }), 500);
})
